import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLong = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 15 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 3.16016H12.16", stroke: "currentColor", strokeWidth: 0.7, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M11.8812 3.16C11.1512 2.43 10.8112 1 10.7812 0C11.7812 1.34 13.0713 2.51 14.6413 3.16C13.0713 3.79 11.8412 5.02 10.7812 6.32C10.8713 5.25 11.1312 3.96 11.8812 3.16Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgArrowLong);
export default ForwardRef;
